document.querySelectorAll('.sortLink').forEach(element => {
    element.addEventListener('click', function (e) {
        e.preventDefault();
        var text = this.textContent.trim();
        document.getElementById('sort').value = text.toLowerCase();
        document.getElementById('SearchPage').submit();
    });
});


document.querySelectorAll('.reveal-overlay .close-button, .reveal-overlay .download-success button').forEach(element => {
    element.addEventListener('click', function () {
        document.querySelectorAll('.reveal-overlay').forEach(overlay => overlay.style.display = 'none');
        document.querySelectorAll('.download-form, .download-success').forEach(form => form.style.display = 'none');
    });
});



function documentFormSubmit($form) {
    documentLoader.submitForm($form);
}

function documentInit($form) {
    documentLoader.form = $form;
}


function ToggleSearch() {
    const element = document.getElementById("search");

    if (element.classList.contains("active")) {
        element.classList.remove("active");
    }
    else {
        element.classList.add("active");
    }

}

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

let documentLoader = {
    form: "",
    data: {
        Name: "",
        Company: "",
        Title: "",
        Email: "",
        CurrentUrl: "",
        Documents: [],
        DocumentId: 0,
        MarketTypes: ""
    },
    showForm: function () {
        $('.error').hide();
        $('.file-error').hide();
        this.data.Documents.push(this.data.DocumentId);

        var form = this.form;
        var documentData = this.data;

        $.post('/api/document/contact', documentData, function (data) {
            if (typeof data == 'undefined') {
                $('.error').show();
            }

            form.find('input[name="n00n4n00000iczvc"]').attr('value', data.market);
            form.find('input[name="n00n6100000hbnyi"]').attr('value', data.message);
        })
    },
    submitForm: function ($form) {
        var documentData = this.data;

        $.get('/api/document?id=' + documentData.DocumentId, function (fileData) {
            if (fileData == '') {
                $('.file-error').show();
                return;
            }

            var documentDownload = document.getElementById('documentDownload');
            documentDownload.setAttribute('href', fileData);
            documentDownload.click();

            $('.download-form').hide();
            $('.download-success').show();
            createCookie("EchodyneDocs", true, 3650);
        }).fail(function () {
            $('.error').show();
        })
    },
    getDocument: function (id) {
        $.get('/api/document?id=' + id, function (data) {
            if (data == '') {
                return;
            }

            var documentDownload = document.getElementById('documentDownload');
            documentDownload.setAttribute('href', data);
            documentDownload.click();
        })
    }
}
document.addEventListener('DOMContentLoaded', (event) => {
    var url = window.location.href;

    if (url.includes('gh_jid') && document.getElementById('careers') !== null) {
        document.getElementById('careers').scrollIntoView();
    }
});
